import { render, staticRenderFns } from "./DeliveryAddress.vue?vue&type=template&id=3b12d352&scoped=true&"
import script from "./DeliveryAddress.vue?vue&type=script&lang=js&"
export * from "./DeliveryAddress.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryAddress.vue?vue&type=style&index=0&id=3b12d352&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b12d352",
  null
  
)

export default component.exports